module.exports = "<div id=\"person-competencesstatus-graph\" class=\"graph\"></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/dashboard/person-competences-status-graph-component.html
// module id = 1418
// module chunks = 1